export default __webpack_public_path__ + "static/media/Rhombus170.d97d6b57.svg";